import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'auth-callback',
  template: `
    <div class="auth-callback">
      <h1>Validando autenticação...</h1>
      <p>Aguarde enquanto finalizamos seu acesso.</p>
    </div>
  `,
  styles: [`
    .auth-callback {
      min-height: 100vh;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 8px;
      color: #1f2933;
      text-align: center;
      padding: 24px;
    }

    .auth-callback h1 {
      margin: 0;
      font-size: 22px;
      font-weight: 600;
      letter-spacing: 0;
    }

    .auth-callback p {
      margin: 0;
      color: #52606d;
      font-size: 14px;
    }
  `]
})
export class AuthCallbackComponent implements OnInit {
  constructor(private authService: AuthService, private router: Router) { }

  async ngOnInit() {
    await firstValueFrom(this.authService.authReady$.pipe(filter(Boolean), take(1)));

    if (this.authService.isAuthenticated()) {
      const returnUrl = sessionStorage.getItem(this.authService.redirectPathKey) || '/projects';
      sessionStorage.removeItem(this.authService.redirectPathKey);
      this.router.navigateByUrl(returnUrl);
      return;
    }

    this.authService.expireSession('/projects');
  }
}
